import { render, staticRenderFns } from "./BlankView.vue?vue&type=template&id=c40f5586&scoped=true&"
import script from "./BlankView.vue?vue&type=script&lang=js&"
export * from "./BlankView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40f5586",
  null
  
)

export default component.exports